jQuery(function ($) {
    function hideSubmit() {
        $('[data-hide-submit=true]').each(function() {
            $(this).removeAttr('data-hide-submit');
            $(this).css('display','none');
            let $input = $('<input type="hidden">');
            $input.attr('name',$(this).attr('name'));
            $input.val($(this).val());
            $(this).after($input);
        });
    }
    hideSubmit();
    $(document).on('change','input[type=radio][data-update]',function () {
        let $form = $(this).closest('form');
        let formData = $form.serialize();
        let target = $(this).data('update');
        let url = $form.attr('action');
        let method = $form.attr('method');
        if (typeof url === typeof undefined) {
            url = window.location.href;
        }
        if (typeof method === typeof undefined) {
            method = 'get';
        }
        $.ajax(url,{
            method: method,
            data: formData,
            success: function(data) {
                var $div = $('<div />');
                $div.html(data);
                $(target).html($div.find(target).html());
                hideSubmit();
            }
        })
    });
});